<template>
  <span class="checkbox-btn" :class="{ isActive: _value && !disabled, isDisabled: disabled }">
    <i-checkbox v-model="_value" size="small" :true-value="trueValue" :false-value="falseValue" :disabled="disabled">
      {{ label }}
    </i-checkbox>
  </span>
</template>

<script>
import { Checkbox } from 'view-design'

export default {
  props: {
    value: {
      type: Number,
      default: 0,
      required: true,
    },
    label: {
      type: String,
      default: '',
      required: false,
    },
    trueValue: {
      default: 1,
    },
    falseValue: {
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    'i-checkbox': Checkbox,
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },
  watch: {
    disabled(val) {
      if (val) this._value = this.falseValue
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox-btn {
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 0;
  padding: 1px 7px 0;
  border: 1px solid #19be6b;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 400;
  color: #19be6b;
  background-color: #fff;
  text-align: center;
  vertical-align: middle;
  line-height: 1.5;
  cursor: pointer;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  background-image: none;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear;

  &.isActive {
    color: #fff;
    background-color: #19be6b;
    border: 1px solid #19be6b;
  }

  &.isDisabled {
    color: #c5c8ce;
    background-color: #f7f7f7;
    border-color: #dcdee2;
  }

  .ivu-checkbox-wrapper {
    margin-right: 0;
    margin-bottom: 0;
    line-height: 1.8;
  }

  .ivu-checkbox {
    margin-right: 4px;
  }
}
</style>
